// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".close-order .el-radio-group .el-radio[data-v-222f65fe] {\n  display: block;\n  margin: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
